import {
	SET_WAREHOUSE_EDIT_STATUS,
	SET_WAREHOUSE_LIST,
} from "../../actions/warehouse";

const ACTION_HANDLERS = {
	[SET_WAREHOUSE_LIST]: (state, action) => ({
		...state,
		warehouseList: action.payload,
	}),
	[SET_WAREHOUSE_EDIT_STATUS]: (state, action) => ({
		...state,
		warehouseEditStatus: action.payload.status,
		warehouseEditData: action.payload.data,
	}),
};
const initialState = {};

export default function warehouseReducer(state = initialState, action) {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
}
